import {useState} from "react";
import "./SegmentButton.css";

interface SegmentButtonProps {
    selectedSegment?: string;
    setSelectedSegment?: any;
    segmentBarOptions?: any;
    handleSegmentClick?: (value: string) => void;
}
const SegmentButton = (props: SegmentButtonProps) => {
    const {selectedSegment, setSelectedSegment, segmentBarOptions, handleSegmentClick} = props;

    return(
        <div className="segment-wrapper">
          {segmentBarOptions?.map(({key, value}) => (
            <div
              onClick = {value === "userDefined"
              ? undefined:
              () => {
                setSelectedSegment(value);
                handleSegmentClick?.(value);
              }}
              className={`segment-container ${selectedSegment === value ? 'active' : ''} ${value === "userDefined" ? "noCursor": ""}`}>
                {<span className={`${selectedSegment === key ? "segment-label" : "nonSegment-label" }`}>{key}</span>}
            </div>
          ))}
        </div>
    )
}

export default SegmentButton;